import { paymentMethodService } from "@/services";
import type { CollectionMode } from "@/types/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";

export function usePaymentMethod() {
	return useQuery({
		queryKey: qk.paymentMethod,
		queryFn: ({ signal }) => paymentMethodService.get(signal),
		// A registration completes at the bank, out of band — there is no event
		// telling this tab it happened. Polling while one is pending is the only
		// way the screen updates without the admin reloading it themselves.
		refetchInterval: (q) =>
			q.state.data?.payment_method?.status === "pending" ? 5_000 : false,
	});
}

export function usePaymentMethodMutations() {
	const qc = useQueryClient();
	const invalidate = () => {
		qc.invalidateQueries({ queryKey: qk.paymentMethod });
		// Collection mode lives on the org too, and the Billing header reads it.
		qc.invalidateQueries({ queryKey: qk.org });
	};

	return {
		register: useMutation({
			mutationFn: (body: { method?: string; contact?: string } = {}) =>
				paymentMethodService.register(body),
			onSuccess: invalidate,
		}),
		revoke: useMutation({
			mutationFn: (id: string) => paymentMethodService.revoke(id),
			onSuccess: invalidate,
		}),
		setMode: useMutation({
			mutationFn: (mode: CollectionMode) =>
				paymentMethodService.setCollectionMode(mode),
			onSuccess: invalidate,
		}),
	};
}
